<script lang="ts">
    import {
        getBestsellingProducts,
        getFeaturedProducts,
        getNewestProducts,
        getProductsByCategory,
        getProductsByIds,
    } from "../../../functions/CommerceAPIs/bigCommerce/product"
    import ProductPreviewList from "./ProductPreviewList.svelte"

    export let block: ContentBlock<"productSlider">
    const productSlider = block.productSlider

    let products: BKDFProduct[] = []
    if (productSlider.productSource == "manual") {
        async function setProductsByIds() {
            if ("productIds" in productSlider) {
                getProductsByIds(productSlider.productIds).then((res) => {
                    products = res
                })
            }
        }
        setProductsByIds()
    } else if (productSlider.productSource == "category") {
        async function setProductsByCategory() {
            if ("categoryId" in productSlider) {
                getProductsByCategory(productSlider.categoryId).then((res) => {
                    products = res
                })
            }
        }
        setProductsByCategory()
    } else if (productSlider.productSource == "bestseller") {
        async function setProductsByBestseller() {
            getBestsellingProducts().then((res) => {
                products = res
            })
        }
        setProductsByBestseller()
    } else if (productSlider.productSource == "newProducts") {
        async function setNewProducts() {
            getNewestProducts().then((res) => {
                products = res
            })
        }
        setNewProducts()
    } else if (productSlider.productSource == "featured") {
        async function setFeaturedProducts() {
            getFeaturedProducts().then((res) => {
                products = res
            })
        }
        setFeaturedProducts()
    } else if ("productIds" in productSlider) {
        getProductsByIds(productSlider.productIds).then((res) => {
            products = res
        })
    }
    $: console.log("products", products, block)
</script>

{#if products.length}
    <ProductPreviewList products="{products}" />
{/if}
